import React, { Component } from 'react';

import { isAposFimInscricaoFimPagamento } from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';

import Table from '../../components/Table/Table';

import { ButtonNewTabCandidatosPorDepAdmin, ButtonNewTabCandidatosPorStatus } from '../Buttons/ButtonsNewTab';

import { numberFormat } from '../../helper/MaskHelper';

export class DadosInscricoesEdicao extends Component {

    newTabCandidatosPorStatus = (qtd, status, query = "") => <ButtonNewTabCandidatosPorStatus qtd={numberFormat(qtd)} status={status} query={query} />
    newTabCandidatosPorDepAdmin = (qtd, depAdmin, query = "") => <ButtonNewTabCandidatosPorDepAdmin qtd={numberFormat(qtd)} depAdmin={depAdmin} query={query} />

    render () {
        const columns = [
            { label: 'Edição', name: 'edicao', func: null, key: true, width: '5', orderLabel: 'asc', },
            { label: 'Candidatos', name: 'candidatos', func: null, key: false, width: '5', },            
            { label: 'Inscrições Finalizadas', name: 'candidatosInscritos', func: (qtd) => this.newTabCandidatosPorStatus(qtd, "FINALIZADO"), key: false, width: '10', },
            { label: 'Inscrições Aguardando Pagamento', name: 'candidatosAguardandoPagamento', func: (qtd) => this.newTabCandidatosPorStatus(qtd, "AGUARDANDO_PAGAMENTO"), key: false, width: '10', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Inscrições Com Pendências', name: 'candidatosComPendencias', func: (qtd) => this.newTabCandidatosPorStatus(qtd, "INICIADO"), key: false, width: '10', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Inscrições Não Finalizados', name: 'candidatosNaoFinalizados', func: (qtd) => this.newTabCandidatosPorStatus(qtd, "INCOMPLETO", "&comEscolaSelecionada=true&comLocalProvaSelecionado=true"), key: false, width: '10', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Inscrições Sem Escola Selecionada', name: 'candidatosSemEscola', func: (qtd) => this.newTabCandidatosPorDepAdmin(qtd, "SEM ESCOLA INFORMADA"), key: false, width: '10' },
            { label: 'Inscrições de Escolas Públicas', name: 'candidatosEscolaPublica', func: (qtd) => this.newTabCandidatosPorDepAdmin(qtd, "PUBLICA"), key: false, width: '10' },
            { label: 'Inscrições de Escolas Privadas', name: 'candidatosEscolaPrivada', func: (qtd) => this.newTabCandidatosPorDepAdmin(qtd, "PRIVADA"), key: false, width: '10' },
            { label: 'Total de Escolas Públicas', name: 'escolasPublicas', func: null, key: false, width: '5' },
            { label: 'Total de Escolas Privadas', name: 'escolasPrivadas', func: null, key: false, width: '5' },
            { label: 'Total de Municípios', name: 'municipios', func: null, key: false, width: '5', },
            { label: 'Total de UF`s', name: 'ufs', func: null, key: false, width: '5', },
        ];

        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table              
                        columns={columns}
                        tableData={this.props.edicoes}
                        actions={[]}
                        page={null}
                        rowsPerPage={null}
                        sort={null}
                        fixedHeader={true}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default DadosInscricoesEdicao;